import { Component, OnInit, Input, Inject } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MasterTemplateCategory } from '../Enum/common.enum';
import { StatusConstant } from '../status/status-constant';
import { LoaderService } from '../../shared/loader/loader.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

@Component({
  selector: 'app-importForm3C',
  templateUrl: './importForm3C.component.html',
  styleUrls: ['./importForm3C.component.scss'] 
})

export class ImportForm3CListComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;  
  formDialog: FormGroup; 
  spinner:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any;
  
  rolesAsssign: any[] = [];
  isOrganizationAdmin: boolean = false;
  isSuperAdmin: boolean = false;

  activeNode: string = "";
  hierarchyList: any;
  breadCrumMenu: any = [];
  FormsubFolderFolderList: any;
  selectButtonShow: boolean = false;
  isShowForm: any = true;
  isSharedWithMe: any = false;
  SharedWithMeactive: boolean = false;
  menuHeaderMyDrive: any=[]=[];
  menuHeader: any=[]=[];

  FormFolderList: any;
  FormFolderListMiddleSection: any = ([] = []);

  isShowMyDrive: any = false;
  isSharedWithMeMyDrive: any = false;
  parentID: number = 0;
  SharedWithMeFormFolderList: any = [] = [];
  SharedWithMeMyDriveFolderList: any = [] = [];
  SharedWithMeMyDriveactive: boolean = false;

  TypeId: number;
  showUrlSignNowUrl: boolean = false;
  LoggedInEmailId:string="";

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID: node.formFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  private _transformerFileManager = (node: FoodNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID: node.fileManagerItemID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  treeControlFileManager = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerFileManager = new MatTreeFlattener(this._transformerFileManager, node => node.level, node => node.expandable, node => node.children);
  dataSourceFileManager = new MatTreeFlatDataSource(this.treeControlFileManager, this.treeFlattenerFileManager);


  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  //dialogRef: MatDialogRef<any, any>;
  
  constructor(public dialogRef: MatDialogRef<ImportForm3CListComponent>, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private formBuilder: FormBuilder,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    private statusConst: StatusConstant,private loaderService: LoaderService,
    private settingsService: SettingService,) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
    this.organizationId = sessionStorage.getItem('organizationID')?? '';
    this.LoggedInEmailId = sessionStorage.getItem('email')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
  }  
  
  ngOnInit(): void {
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if (this.rolesAsssign.length > 0) {
      this.isOrganizationAdmin = this.rolesAsssign.find(m => m.roleName == 'Organization Admin') != undefined;
      this.isSuperAdmin = this.rolesAsssign.find(m => m.roleName == 'Super Admin') != undefined;
    }
   
    this.data;
    var modulename = Object.values(this.data)[0];
    if(modulename=="Task"){
      this.showUrlSignNowUrl=true;
    }else{
      this.showUrlSignNowUrl=false;
    }
    this.activeNode = "";
    this.dataSource.data = [];
    this.selectButtonShow = false;
    this.isShowForm = true;
    this.isSharedWithMe = false;
    this.SharedWithMeactive = false;
    this.menuHeaderMyDrive = [];
    this.menuHeader = [];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();

  }  


  // ======= Middle Panel FormFolderList Quick Form and Import Form ========//

  getFormFolderListLeftPanel() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.settingsService.getFormFolderList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FormFolderList = this.responseHolder.data;
          if (this.FormFolderList.length > 0) {
            this.dataSource.data = this.FormFolderList;
          }
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  getFormFolderListMiddlePanel() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.settingsService.getFormFolderWithFormTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FormFolderListMiddleSection = this.responseHolder.data;
          this.FormFolderListMiddleSection.forEach(e => {
            e.isChecked = false
          });
        } else {
        }
      } else {
      }
    });
  }


  GetAllForms() {
    this.activeNode = "";
    this.dataSource.data = [];
    this.selectButtonShow = false;
    this.isShowForm = true;
    this.isSharedWithMe = false;
    this.isShowMyDrive = false;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeactive = false;
    this.menuHeader = [];
    this.menuHeaderMyDrive = [];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
  }


   // ======= Left Panel FormFolderList Quick Form and Import Form ========//

   getFormFolderWithTemplatesLeftPanel(form) {
    this.selectButtonShow = false;
    this.activeNode = form.formFolderID;
    var ReqModel = {
      formFolderID: form.formFolderID,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.settingsService.getFormFolderWithFormTemplates(ReqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormsubFolderFolderList = this.responseHolder.data;
          this.settingsService.GetParentFormFolderHierarchy(ReqModel).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) {
                this.hierarchyList = response.data.hierarchy;
                if (this.hierarchyList == null || this.hierarchyList == undefined) {
                  this.breadCrumMenu = [];
                  this.menuHeader = this.breadCrumMenu;
                  this.FormFolderListMiddleSection = this.FormsubFolderFolderList;
                  this.parentID = form.parentID;
                } else {
                  this.breadCrumMenu = [];
                  this.hierarchyList.forEach(e => {
                    this.breadCrumMenu.push({ label: e.formFolderName, id: e.formFolderID, icon: 'navigate_next' });
                  });
                  this.menuHeader = this.breadCrumMenu;
                  this.FormFolderListMiddleSection = this.FormsubFolderFolderList;
                  this.parentID = form.parentID;
                  this.isShowForm = true;
                  this.isSharedWithMe = false;
                  this.SharedWithMeactive = false;
                }
              }
            }
          });
        }
        else {
        }
      }
      else {
      }
    });

   }


   // =========== For Shared with me  =========// 

  getSharedWithMe() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.settingsService.getFormFolderSharedWithMeList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.SharedWithMeFormFolderList = this.responseHolder.data;
          this.SharedWithMeFormFolderList.forEach(e => {
            e.isChecked = false
          });
          if(this.SharedWithMeFormFolderList==null){
            this.SharedWithMeFormFolderList=[];
          }
          if (this.SharedWithMeFormFolderList != null) {
            this.SharedWithMeFormFolderList.map((res) => {
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }
              return res;
            });
          }

          this.selectButtonShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = true;
          this.SharedWithMeactive = true;
          this.SharedWithMeMyDriveactive = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = false;
          this.activeNode = "";
          this.menuHeader = [];
          this.parentID = 0;
        }
        else {
          this.SharedWithMeFormFolderList = [];
          this.selectButtonShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = true;
          this.SharedWithMeactive = true;
          this.SharedWithMeMyDriveactive = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = false;
          this.activeNode = "";
          this.menuHeader = [];
          this.parentID = 0;
        }
      }
      else {
      }
    });
  }


  breadCrumbMainClick() {
    this.FormFolderListMiddleSection = [];
    //this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
    this.menuHeader = [];
    this.TypeId = 0;
    this.parentID = 0;
    this.selectButtonShow = false;
    this.activeNode = "";
  }

  closeAll(){
    this.FormID=0;
   // this.dialog.closeAll(); 
   this.dialogRef.close();
  }

  breadCrumb(menu:any, index:any) {
    this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.FormFolderList = menu[index].items;
    }
    var data = this.menuHeader[index];
    this.getformnavigate(data);
    this.selectButtonShow = false;
    this.parentID = data.id;
  }

  getformnavigate(form:any) {
    this.selectButtonShow = false;
    this.activeNode = form.id;
    var ReqModel = {
      formFolderID: form.id,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.settingsService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormFolderListMiddleSection = this.responseHolder.data;
        } else {
        }
      } else {
      }
    });
  }


  PlaceholderName: string = "";
  PlaceholderID: string = "";
  DocumentFolderID: string = "";
  FormID: number = 0
  fileManagerID: string = "";
  PlaceholderNameFound: boolean = false;
  batchName:string="";
  selectedFormForTaskDetail:any;

  radioChange(form:any, FormOrShared:any) {
    if(form.formType==2 || form.formType==3){
      return;
    }
    this.batchName = form.name;
    if (FormOrShared == "SharedWithMe") {
      this.activeNode = "";
      this.SharedWithMeFormFolderList.forEach(e => {
        e.isChecked = false
      });
    }
    if (FormOrShared == "MyForm") {
      this.FormFolderListMiddleSection.forEach(e => {
        e.isChecked = false
      });
    }

    if (form.type == 1 && FormOrShared == "MyForm") {
      this.selectButtonShow = false;
      this.getform(form, FormOrShared);
    }

    if (form.type == 2) {
      if (this.PlaceholderNameFound == true) {
        this.PlaceholderName = form.name;
        if (this.PlaceholderID == undefined)
          this.PlaceholderID = "0";
      }
      this.FormID = form.id;
      this.selectedFormForTaskDetail = form;
      //this.batchName = form.name;
      this.selectButtonShow = true;
      if (FormOrShared == "MyForm") {
        this.FormFolderListMiddleSection.forEach(e => {
          if (e.id == form.id) {
            e.isChecked = true
          }
        });
      }
      if (FormOrShared == "SharedWithMe") {
        this.SharedWithMeFormFolderList.forEach(e => {
          if (e.id == form.id) {
            e.isChecked = true
          }
        });
      }
    }
  }

  getform(form, FormOrSharedWithMe) {
    if (FormOrSharedWithMe == "MyForm") {
      this.activeNode = form.id;
    }
    if (FormOrSharedWithMe == "SharedWithMe") {
      this.activeNode = "";
    }
    this.TypeId = form.type;
    var type = form.type;
    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.settingsService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.FormFolderListMiddleSection = this.responseHolder.data;
            this.parentID = form.id;

            this.menuHeader.push({
              label: form.name,
              id: form.id,
              icon: 'navigate_next',
            });

            this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);

          } else {
          }
        } else {
        }
      });
    } else {
    }
  }

  getIsFavorite(isFavorite) {
    isFavorite = isFavorite.isFavorite;
    return isFavorite;
  }

  breadCrumbMainSHaredWithMeClick() {
    this.selectButtonShow = false;
    this.getSharedWithMe();
    this.menuHeader = [];
    this.parentID = 0;
  }

  getFormFolderWithFormTemplatesSharedWithMe(form) {
    this.TypeId = form.type;
    var type = form.type;
    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        permissionType: form.permissionType,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.settingsService.getFormFolderWithFormTemplatesSharedWithMe(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.SharedWithMeFormFolderList = this.responseHolder.data;
            if(this.SharedWithMeFormFolderList==null){
             this.SharedWithMeFormFolderList=[];
            }
            if (this.SharedWithMeFormFolderList != null) {
              this.SharedWithMeFormFolderList.map((res) => {
                if (res.sharedbyFirstName != null) {
                  res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
                }
                if (res.sharedbyLastName != null) {
                  res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
                }
                return res;
              });
            }
            this.parentID = form.id;
            this.menuHeader.push({
              label: form.name,
              id: form.id,
              icon: 'navigate_next',
              permissionType: form.permissionType,
            });

            this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);

          } else {
          }
        } else {
        }
      });
    } else {
    }
  }
  

  SelectFormSubmit() {
    this.data;
    var modulename = Object.values(this.data)[0];
    
    if(modulename=="Core"){
      this.CreateProjectsforMultipleCCC(Object.values(this.data)[1],1);
    }  
    if(modulename=="Contact"){
      this.CreateProjectsforMultipleCCC(Object.values(this.data)[1],2);
    }
    if(modulename=="Company"){
      this.CreateProjectsforMultipleCCC(Object.values(this.data)[1],3);
    }
  }

  async CreateProjectsforMultipleCCC(selectedRecords:any,cType){
    var bathCCC:any=[];
    selectedRecords = selectedRecords.filter(x=> x.email !="");
    if (selectedRecords.length > 0) {     
      for (let i = 0; i < selectedRecords.length; i++) {   
        var obj={
          cid: selectedRecords[i].selectedRecord,
          email: selectedRecords[i].email,
        }   
        bathCCC.push(obj);
      }
    }else{
      this.toastr.warning("Selected record is not email id.", '', {
        timeOut: 3000,
      });
      return;
    }
    this.loaderService.show();
    var ReqModel = {
      batchCCC: bathCCC,
      formID:this.FormID,
      cType: cType,  //1 Core,  2 Contact , 3 Company    
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      batchName:this.batchName
    }
   // return;
    this.spinner = true;
    this.selectButtonShow=false;
    const result = await this.settingsService.createProjectsforMultipleCCC(ReqModel).toPromise();
    if (result === true) {
      this.spinner = false;
      this.loaderService.hide();  
      this.toastr.success("This process will take approximately 2–3 minutes for the form placeholder to appear and for the project to be created for the selected records. Please check accordingly. Thank you for your patience.", '', {
        timeOut: 5000,
      });    
      // this.toastr.success("Form send successfully.", '', {
      //   timeOut: 3000,
      // });
      this.dialogRef.close('Added');
      this.FormID=0;
      //this.closeAll();
    }
    else {
      this.selectButtonShow=true;
      this.toastr.error("Form send failed.", '', {
        timeOut: 3000,
      });
      this.spinner = false;
      this.loaderService.hide();
    }
  }

  formTokenLink:string="";
  signNowUrl:string="";

  SelectUrl(){    
    this.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+this.selectedFormForTaskDetail.formTokenLink;
    this.signNowUrl=this.signNow(this.selectedFormForTaskDetail.formTokenLink,this.selectedFormForTaskDetail);
    var obj={
      token:this.selectedFormForTaskDetail.formTokenLink,
      url:this.formTokenLink,
      name: this.selectedFormForTaskDetail.name,
      formType:this.selectedFormForTaskDetail.formType,
      formID:this.selectedFormForTaskDetail.id,
      signNowUrl: this.signNowUrl
     }
     this.dialogRef.close(obj);
  }
 
  SelectSignNowUrl(){
    this.selectedFormForTaskDetail;
    this.signNowUrl=this.signNow(this.selectedFormForTaskDetail.formTokenLink,this.selectedFormForTaskDetail);
    var obj={
      url:this.signNowUrl,
      name: this.selectedFormForTaskDetail.name
     }
     this.dialogRef.close(obj);
  }

  signNow(token: any,form:any) {
    let params = decodeURIComponent(token);
    const decryptedTokenString = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
    let decryptedToken = JSON.parse(decryptedTokenString)
    let objModel = {
      "OfficeID": decryptedToken.OfficeID,
      "IsReadOnlyFromSentPage": false,
      "ProjectID": decryptedToken.FormID,
      "FormID": decryptedToken.FormID,
      "CoreID": 0,
      "CorePlaceholderID": 0,
      "DocumentHtmls": "",
      "participantJsonList": "",
      "documentFolderID": 0,
      "email": "",
      "DatabaseID": decryptedToken.DatabaseID,
      "OrganizationID": decryptedToken.OrganizationID,
      "UserID": decryptedToken.UserID
    };
    let jsonStringToken = JSON.stringify(objModel);
    token = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonStringToken);
    token = encodeURIComponent(token);

    //1pdf 2 tabular 3 html{
    let url = '';
    if (form.formType == 1)
      url =window.location.href.split(window.location.pathname)[0] +"/request/signature?token=" +token +"&type=1" +"&signnowFrom=" +encodeURIComponent(this.LoggedInEmailId);
    else if (form.formType == 2)
      url = window.location.href.split(window.location.pathname)[0] + "/request/tabularsignature?token=" + token + "&type=1";
   return url
  }

}

interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}


/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}


interface FoodNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}


interface ExampleFlatNodeFileManager {
  expandable: boolean;
  name: string;
  level: number;
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}